import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (!isLoggedIn) {
        return <Navigate to="/agency-dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;
